export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  videoCount: number;
}

export const categories: Category[] = [
  {
    slug: 'aiqing-ju',
    name: '爱情剧',
    description: '温馨浪漫的爱情故事，感受心动瞬间',
    icon: 'ri-heart-line',
    videoCount: 48,
  },
  {
    slug: 'dushi-ju',
    name: '都市剧',
    description: '现代都市生活百态，贴近现实人生',
    icon: 'ri-building-line',
    videoCount: 36,
  },
  {
    slug: 'guzhuang-ju',
    name: '古装剧',
    description: '穿越古今的唯美传奇，领略风华绝代',
    icon: 'ri-ancient-gate-line',
    videoCount: 42,
  },
  {
    slug: 'xuanyi-ju',
    name: '悬疑剧',
    description: '扣人心弦的推理故事，层层揭秘真相',
    icon: 'ri-search-eye-line',
    videoCount: 28,
  },
  {
    slug: 'jiaju-ju',
    name: '家居生活',
    description: '美好家居灵感，打造温馨舒适的家',
    icon: 'ri-home-heart-line',
    videoCount: 25,
  },
  {
    slug: 'meishi-ju',
    name: '美食记录',
    description: '诱人美食之旅，品味舌尖上的幸福',
    icon: 'ri-restaurant-line',
    videoCount: 32,
  },
  {
    slug: 'lvxing-ju',
    name: '旅行风光',
    description: '世界各地的绝美风景，一起云游四方',
    icon: 'ri-earth-line',
    videoCount: 30,
  },
  {
    slug: 'qinzi-ju',
    name: '亲子时光',
    description: '温馨亲子互动，记录成长的美好瞬间',
    icon: 'ri-parent-line',
    videoCount: 20,
  },
];